import moment from "moment";
import React from "react";
import { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { Button } from "../components/common/Forms";
import { SITE_URL } from "../api/common";
import Icon from "../components/common/Icon";

export const useLocationQuery = () => {
  const { search } = useLocation();
  let sList = search.slice(1, search.length).split("&");

  const params = sList.reduce((acc, cur) => {
    const [k, v] = cur.split("=");
    return { ...acc, [k]: v };
  }, {});
  return params;
};

export const shuffle = (v) => {
  const array = v ? [...v] : v;
  if (array) {
    return array.sort(() => Math.random() - 0.5);
  }
  return array;
};

export const autoHyphen = (val) => {
  if (!val) return "";
  const v = val
    .replace(/[^0-9]/g, "")
    .replace(/^82/, "")
    .replace(/^10/, "010");
  if (!v) return "";
  return v.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`);
};

export const getStatusBadge = (sDate, eDate) => {
  if (moment(new Date()).isBefore(sDate)) {
    return {
      value: -1,
      label: (
        <div className="badge badge-sm bg-opacity-50 border-none py-[1px] w-13">
          강의 전
        </div>
      ),
    };
  }
  if (moment(new Date()).isBefore(eDate)) {
    return {
      value: 0,
      label: (
        <div className="badge badge-info badge-sm text-white w-12">진행중</div>
      ),
    };
  }
  if (moment(new Date()).isAfter(eDate)) {
    return {
      value: 1,
      label: (
        <div className="badge badge-success badge-sm text-white w-8">완료</div>
      ),
    };
  }
};

export const getItemButtons = ({ item, data, id, target, auth }) => {
  let targetText = target ? `?target=${target}` : "";
  const handleLink = async () => {
    await navigator.clipboard.writeText(
      `${SITE_URL()}${item}/response/${id}?target=${target}`
    );
    const msg = `클립보드에 ${
      target === "parent" ? "학부모" : "학생"
    } 설문 주소가 복사되었습니다.`;
    alert(msg);
  };
  if (data) {
    return {
      value: 1,
      label: (
        <div className="inline-flex gap-1">
          {item === "survey" && (
            <Button type="primary" size="xs" outlined onClick={handleLink}>
              <Icon name="share" size="sm" className="inline-block" />
              URL
            </Button>
          )}
          <Button
            type="primary"
            size="xs"
            onClick={() =>
              window.open(`/${item}/update/${data._id}${targetText}`, "_self")
            }
          >
            <Icon name="pencil-square" size="sm" className="inline-block" />
            수정
          </Button>
          {item === "survey" && (
            <Button
              type="primary"
              size="xs"
              onClick={() =>
                window.open(
                  `/${item}/result/${data.lecture_id}${targetText}`,
                  "_self"
                )
              }
            >
              <Icon
                name="document-chart-bar"
                size="sm"
                className="inline-block"
              />
              결과
            </Button>
          )}
        </div>
      ),
    };
  }
  if (auth) {
    return {
      value: 0,
      label: (
        <Button
          type="primary"
          size="xs"
          onClick={() =>
            window.open(`/${item}/add/${id}${targetText}`, "_self")
          }
          outlined
        >
          등록
        </Button>
      ),
    };
  }
};

export const MetaTag = (props) => {
  return (
    <Helmet>
      <title>{props.title}</title>

      <meta name="description" content={props.description} />
      {/* <meta name="keywords" content={props.keywords} /> */}

      <meta property="og:type" content="website" />
      <meta property="og:title" content={props.title} />
      <meta property="og:site_name" content={props.title} />
      <meta property="og:description" content={props.description} />
      <meta property="og:image" content={props.imgsrc} />
      <meta property="og:url" content={props.url} />

      <meta name="twitter:title" content={props.title} />
      <meta name="twitter:description" content={props.description} />
      <meta name="twitter:image" content={props.imgsrc} />

      <link rel="canonical" href={props.url} />
    </Helmet>
  );
};

const hasFocus = () => typeof document !== "undefined" && document.hasFocus();

export const useWindowFocus = () => {
  const [focused, setFocused] = useState(hasFocus); // Focus for first render

  useEffect(() => {
    setFocused(hasFocus()); // Focus for additional renders

    const onFocus = () => setFocused(true);
    const onBlur = () => setFocused(false);

    window.addEventListener("focus", onFocus);
    window.addEventListener("blur", onBlur);

    return () => {
      window.removeEventListener("focus", onFocus);
      window.removeEventListener("blur", onBlur);
    };
  }, []);

  return focused;
};
